import * as React from 'react';
import { styled, createTheme, ThemeProvider } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import { useSelector, useDispatch } from 'react-redux';
import { useEffect, useRef ,useState } from 'react';
import Grid from '@mui/material/Grid';
import DataGrid from 'react-data-grid';
import LinearProgress from '@mui/material/LinearProgress';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import IconButton from '@mui/material/IconButton';
import TextField from '@mui/material/TextField';
import { useNavigate } from "react-router-dom";
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import { addOrUpdateItem, clearCustomerPortalUserId, clearSelectedSTOrder, clearSTOrderData, deleteAllItems, deleteItem, fetchBrands, fetchCusomerExcludedFromRequiredTools, fetchLensBrands, fetchLensCyls, fetchLensIndexes, fetchLensSphs, fetchLensTypes, fetchMatrixQuantity, fetchProduct, fetchProducts, getSTOrderPreview, resetSTOrderResultBox, setCustomerPortalUserId, setLeftValue, setOUValue, setRightValue, setSTOrderCloseMatrix, setSTOrderDateMustDelivered, setSTOrderDescription, setSTOrderLensCyls, setSTOrderLensIndexes, setSTOrderLensSphs, setSTOrderOpenMatrix, setSTOrderPayType, setSTOrderResultBox, setSTOrderSelectedLensBrand, setSTOrderSelectedLensCyl, setSTOrderSelectedLensIndex, setSTOrderSelectedLensSph, setSTOrderSelectedLensType, setSTOrderSelectedProduct, setSTOrderSelectedQuantity, setSTPreviewItemsDialogClose, submitSTOrder, updateAxisData, updateConsumerData, updateNeedToolsData, updateOpticianData, updateNeedCutData, NeedCutOptions } from '../slices/storder.slice';
import Autocomplete from '@mui/material/Autocomplete';
import { addComma, removeComma, separateNumber, ValidateSTOrder } from '../helpers/mmg';
import Switch from '@mui/material/Switch';
import FormControlLabel from '@mui/material/FormControlLabel';
import persian from "react-date-object/calendars/persian"
import persian_fa from "react-date-object/locales/persian_fa"
import DatePicker from "react-multi-date-picker";
import {Iconl2} from '../assets/images/Iconl2'
import {Iconr2} from '../assets/images/Iconr2'
import {Iconou2} from '../assets/images/Iconou2'
import {Iconl1} from '../assets/images/Iconl1'
import {Iconr1} from '../assets/images/Iconr1'
import {Iconou1} from '../assets/images/Iconou1'
import QrCode2Icon from '@mui/icons-material/QrCode2';
import DeleteIcon from '@mui/icons-material/Delete';
import { useForm, Controller } from 'react-hook-form'
import Button from '@mui/material/Button';
import AppsIcon from '@mui/icons-material/Apps';
import { deleteAllMatrix } from '../slices/matrix.slice';
import Checkbox from '@mui/material/Checkbox';
import BeenhereIcon from '@mui/icons-material/Beenhere';
import Tooltip from '@mui/material/Tooltip';
import STPreviewItems from './STPreviewItems';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Alert from '@mui/material/Alert';
import CheckIcon from '@mui/icons-material/Check';
import AddBoxIcon from '@mui/icons-material/AddBox';
import CancelIcon from '@mui/icons-material/Cancel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';

export const zeroPad = (num, places) => String(num).padStart(places, '0');

const boxSX = {
   backgroundColor : '#FFEB3B', color: '#37474F' ,
  "&:hover": {
    color: '#FFEB3B',
    backgroundColor: '#37474F'
  },
};



export const ST = () => {

  const [open, setOpen] = React.useState(false);

 

  const dispatch = useDispatch();
  //const { user: authUser } = useSelector(x => x.auth);  
  const authUser = JSON.parse(localStorage.getItem('user'))

  const stOrder = useSelector(x => x.stOrder);
  const matrix = useSelector(x => x.matrix);
  //const defaultValues = useSelector(x => x.defaultValue);
  const defaultValues = JSON.parse(localStorage.getItem('defaultValue'));
  const barcodeItemRef = useRef();
  const { register, handleSubmit, control, formState: { errors }} = useForm();


  let navigate = useNavigate();


  const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'right',
    //color: theme.palette.text.secondary,
  }));

  //این اوکیه
  //const [searchParams] = useSearchParams();
  //let entityId = searchParams.get("entityId");

 //let entityId = invoices.selectedInvoiceId;

const columns = [
  {
    name: 'ردیف',
    key: 'RowId',
    width: '2%',
  }, 
  //{
  //  key: 'RightProductCode',
  //  name: 'کد محصول',
  //  width: '15%',
  //  resizable: true,
  //  sortable: true,
  //},
  {
    key: 'RightProductTitle',
    name: stOrder.items.some(x => x.LeftProductId !== null) || stOrder.isLeftOn || stOrder.isRightOn || stOrder.isOUOn ? 'محصول(عدسی سمت راست)' : 'محصول',
    width: '22%',
    resizable: true,
    sortable: true,
    //editor : textEditor,
    /*
    headerRenderer(props) {
      return ( "" );
    },
    formatter(props) {
      console.log(props.row);
          return  <TextField size="small" style={{ padding : '0px' , paddingInline : '1px' }} value={props.row.ItemName}/>;
    }
    */
  },
  {
    key: 'LeftProductTitle',
    name: stOrder.items.some(x => x.LeftProductId !== null) || stOrder.isLeftOn || stOrder.isRightOn || stOrder.isOUOn? 'محصول(عدسی سمت چپ)' : '',
    width: '22%',
    resizable: true,
    sortable: true,

  },
  {
    key: 'Quantity',
    name: 'تعداد',
    width: '9%',
    resizable: true,
    sortable: true,
    formatter(props) {
      //console.log(props.row);
          return <div className='dataGridRowDiv'>
          <Tooltip title="اضافه"><IconButton className='addRemoveIconBtn' fontSize="small" color="secondary" aria-label="add an alarm"  onClick={(e) => handleRowValueChange(e,'AddQuantity', props, props.row.ProductId , props.row.RowId)} disabled={props.row.LeftProductTitle !== "-" || stOrder.isLeftOn || stOrder.isRightOn}>
            <AddCircleIcon sx={{ color: '#357a38' }}/>
          </IconButton></Tooltip>
          <TextField size="small"  sx={{ width: 50 }} style={{ padding : '0px' , paddingInline : '1px' }} value={props.row.Quantity} 
            onChange={(e) => handleRowValueChange(e,'Quantity', props, props.row.ProductId , props.row.RowId)} 
            disabled={props.row.LeftProductTitle !== "-" || stOrder.isLeftOn || stOrder.isRightOn}/>
          <Tooltip title="کسر"><IconButton className='addRemoveIconBtn' fontSize="small" color="secondary" aria-label="add an alarm"  onClick={(e) => handleRowValueChange(e,'RemoveQuantity', props, props.row.ProductId , props.row.RowId)} disabled={props.row.LeftProductTitle !== "-" || stOrder.isLeftOn || stOrder.isRightOn}>
            <RemoveCircleIcon sx={{ color: '#ff1744' }} />
          </IconButton></Tooltip>
                </div>;
    }
  },
  {
    key: 'Optician',
    name: 'عینک ساز',
    width: '11%',
    resizable: true,
    sortable: true,
    formatter(props) {
      return <div className='dataGridRowDiv'>
      <TextField InputProps={{ inputProps: { maxLength: 18 } }} size="small" style={{ padding : '0px' , paddingInline : '1px' }} value={props.row.Optician} 
        disabled={props.row.LeftProductTitle === "-" }
        onChange={(e) => handleRowValueChange(e,'Optician', props, props.row.ProductId , props.row.RowId)} />
            </div>;
    }
  },
  {
    key: 'Consumer',
    name: 'مصرف کننده',
    width: '11%',
    resizable: true,
    sortable: true,
    formatter(props) {
          return <div className='dataGridRowDiv'>
          <TextField InputProps={{ inputProps: { maxLength: 18 } }} size="small" style={{ padding : '0px' , paddingInline : '1px' }} value={props.row.Consumer} 
          fullWidth={true}
          disabled={props.row.LeftProductTitle === "-" }
            onChange={(e) => handleRowValueChange(e,'Consumer', props, props.row.ProductId , props.row.RowId)} />
                </div>;
    }
  },
  {
    key: 'NeedCut',
    name: 'خدمات تراش',
    width: '9%',
    resizable: true,
    sortable: true,
    formatter(props) {
        return (
            <div className='dataGridRowDiv' >
                <FormControl fullWidth size="small" style={{ margin: 0 }}>
                    <Select
                        value={props.row.NeedCut || ''} 
                        disabled={props.row.LeftProductTitle === "-"}
                        onChange={(e) => handleRowValueChange(e, 'NeedCut', props, props.row.ProductId , props.row.RowId)}
                        displayEmpty
                        //inputProps={{ 'aria-label': 'Select Consumer' }}
                    >
                        {NeedCutOptions.map((option) => (
                            <MenuItem key={option.value} value={option.value}>
                                {option.label}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </div>
        );
    }
},
  /*
  {
    key: 'Axis',
    name: 'Axis',
    width: '5%',
    resizable: true,
    sortable: true,
    formatter(props) {
          return <div className='dataGridRowDiv'>
          <TextField size="small" style={{ padding : '0px' , paddingInline : '1px' }} value={props.row.Axis} type="number" 
            disabled={props.row.LeftProductTitle === "-"}
            onChange={(e) => handleRowValueChange(e,'Axis', props, props.row.ProductId , props.row.RowId)} />
                </div>;
    }
  },
  */
  {
    key: 'NeedTools',
    name: 'لوازم',
    width: '5%',
    resizable: true,
    sortable: true,
    formatter(props) {
      return <div className='dataGridRowDiv'>
      <Checkbox
        checked={props.row.NeedTools}
        //disabled={(props.row.RightProductTitle !== null && props.row.RightProductTitle !== undefined && !props.row.RightProductTitle.toLowerCase().startsWith("custom") && !stOrder.cusomerExcludedFromRequiredTools)}
        disabled={(props.row.RightProductTitle !== null && props.row.RightProductTitle !== undefined && !stOrder.cusomerExcludedFromRequiredTools)}
        onChange={(e) => handleRowValueChange(e,'NeedTools', props, props.row.ProductId , props.row.RowId)} 
        inputProps={{ 'aria-label': 'controlled' }}
      />
            </div>;
     }
  },
  /*
  {
    key: 'Fee',
    name: 'فی',
    width: '7%',
    resizable: true,
    sortable: true,
    formatter(props) {
      //console.log(props.row);
          return <span>{addComma(props.row.Fee.toString())}</span>
    }
  },
  {
    key: 'Price',
    name: 'کل',
    type: 'number',
    width: '7%',
    resizable: true,
    sortable: true,
    formatter(props) {
      //console.log(props.row);
          return <span>{addComma(props.row.Price.toString())}</span>
    }
  },
    */
  {
    width: '3%',
    name : <Tooltip title="حذف همه اقلام">
            <IconButton color="secondary" aria-label="add an alarm"  onClick={(e) => handleHeaderClick(e,'RemoveQuantity')} disabled={stOrder.items.length == 0}>
            <DeleteIcon sx={{ color: '#ff1744' }} />
            </IconButton>
           </Tooltip>,
    key: 'Operation',
    formatter(props) {
      return <Tooltip title="حذف"><IconButton color="secondary" aria-label="add an alarm" 
      sx={{ width: 50 }} onClick={(e) => handleOperationOnItem(e,'RemoveItem', props, props.row.ProductId , props.row.RowId)}>
        <DeleteIcon sx={{ color: '#ff1744' }} />
      </IconButton></Tooltip>;
    },
  }
];

   useEffect(() => {

    dispatch(fetchCusomerExcludedFromRequiredTools({authUser}));
    //dispatch(clearSTOrderData());
    dispatch(fetchLensBrands({authUser}));

    if(stOrder.customerPortalUserId !== undefined && stOrder.customerPortalUserId !== null && stOrder.customerPortalUserId !== "")
    {
      dispatch(setCustomerPortalUserId(stOrder.customerPortalUserId));
    }
    else if(authUser.underControlUsers !== undefined && authUser.underControlUsers !== null && authUser.underControlUsers.length > 0){
      dispatch(setCustomerPortalUserId(authUser.underControlUsers[0].Value));
    }
    //var theDate = new Date();
    //var day = zeroPad(theDate.getDate() , 2);
    //var month = zeroPad(theDate.getMonth() , 2);
    //var year = theDate.getFullYear();
    //dispatch(setSTOrderDateMustDelivered(year + "/" + month + "/"+ day));

   }, []);

   useEffect(() => {
    //dispatch(clearSelectedSTOrder());
    //dispatch(fetchLensBrands({authUser}));
    console.log("Start Adding Items");
    matrix.itemsToAddFromMatrix.map((item) => {
      dispatch(addOrUpdateItem({selectedRowId : 0 , selectedProductId : item.selectedProductId , selectedProductCode : item.selectedProductCode, selectedProductTitle : item.selectedProductTitle , selectedQuantity : item.selectedQuantity , selectedFee : item.selectedFee , addQuantityToCurrent : false , authUser , customerPortalFinalserRole : defaultValues.PortalUsers.find(r => r.ID == stOrder.customerPortalUserId) ? defaultValues.PortalUsers.find(r => r.ID == stOrder.customerPortalUserId).Role : "" }));
    });

    dispatch(deleteAllMatrix());

   }, matrix.itemsToAddFromMatrix);


   const handleOperationOnItem = (e , changingItemType, props, productId, rowId) => {
    switch(changingItemType) {
      case 'RemoveItem':
      dispatch(deleteItem({selectedRowId : rowId }));
      break;
      default:
        // code block
    }
   }

   const handleSubmitOrder = () =>{

    var errors = ValidateSTOrder(stOrder);

    console.log(errors);
    if(errors.length === 0){
      dispatch(getSTOrderPreview({ stOrder : stOrder , authUser}));
    }else{
      var errorMessage = '';
      errors.map((err) => {
        errorMessage += err + '</hr>';
      });
      console.log(errorMessage);
      dispatch(setSTOrderResultBox({message : errorMessage , type : 1}));
  
    }
   }

   const handleYes = () => {
    setOpen(false);


    var errors = ValidateSTOrder(stOrder);

    console.log(errors);
    if(errors.length === 0){
      dispatch(submitSTOrder({ stOrder : stOrder , authUser}));
    }else{
      var errorMessage = '';
      errors.map((err) => {
        errorMessage += err + '</hr>';
      });
      console.log(errorMessage);
      dispatch(setSTOrderResultBox({message : errorMessage , type : 1}));
  
    }

  };

  const handleClose = () => {
    setOpen(false);
  };
  const handleNo = () => {
    setOpen(false);
  };
  const handleDescriptionChange = (e) =>{

    dispatch(setSTOrderDescription(e.target.value));
  
  }
   const handleDirectSubmitOrder = () =>{
    dispatch(setSTOrderPayType(1));
    setOpen(true);
   }

   
   const handleDirectSubmitOrderOnlinePayment = () =>{

    dispatch(setSTOrderPayType(2));
    setOpen(true);
   }
  //const handleCloseMatrix = () =>{
  //  dispatch(setSTOrderCloseMatrix());
  //}

  const onDateMustDeliveredSelectedHandler = (e) =>{
    var day = zeroPad(e.day , 2);
    var month = zeroPad(e.month.number , 2);
    var year = e.year;
  
    dispatch(setSTOrderDateMustDelivered(year + "/" + month + "/"+ day));
    
  }
  const handleOpenMatrix = () =>{

    dispatch(fetchMatrixQuantity({brandId : stOrder.selectedLensBrandId ,lensTypeId : stOrder.selectedLensTypeId , lensIndexId : stOrder.selectedLensIndexId , stockId : -1 , authUser }));
    //dispatch(setSTOrderOpenMatrix());
    navigate('/stmatrix');
        
  }
  
  const handleHeaderClick = (e) => {

    dispatch(deleteAllItems());
  }

  const handleCloseMessageBox = () =>{
    dispatch(resetSTOrderResultBox());
    //navigate('/ST');
  }
  const handleCloseMessageBoxAndGotoOrderList = () =>{
    dispatch(resetSTOrderResultBox());
    navigate('/Orders');
  }
  
  const handleRowValueChange = (e , changingItemType, props, productId, rowId) => {
    //console.log(changingItemType);
    switch(changingItemType) {
      case 'Quantity':

        dispatch(addOrUpdateItem({selectedRowId : rowId , selectedProductId : productId , selectedProductCode : "", selectedProductTitle : "" , selectedQuantity : e.target.value , addQuantityToCurrent : false,  selectedFee : 0 , authUser, customerPortalFinalserRole : defaultValues.PortalUsers.find(r => r.ID == stOrder.customerPortalUserId) ? defaultValues.PortalUsers.find(r => r.ID == stOrder.customerPortalUserId).Role : ""}));

        // code block
        //console.log(props.row.Number);
        break;
      case 'AddQuantity':
        //console.log("Value is "+ value);
        dispatch(addOrUpdateItem({selectedRowId : rowId , selectedProductId : productId , selectedProductCode : "", selectedProductTitle : "" , selectedQuantity : 1 , addQuantityToCurrent : true,  selectedFee : 0 , authUser, customerPortalFinalserRole : defaultValues.PortalUsers.find(r => r.ID == stOrder.customerPortalUserId) ? defaultValues.PortalUsers.find(r => r.ID == stOrder.customerPortalUserId).Role : ""}));


        // code block
        break;
      case 'RemoveQuantity':
          //console.log("Value is "+ value);
          dispatch(addOrUpdateItem({selectedRowId : rowId , selectedProductId : productId , selectedProductCode : "", selectedProductTitle : "" , selectedQuantity : -1 , addQuantityToCurrent : true,  selectedFee : 0 , authUser, customerPortalFinalserRole : defaultValues.PortalUsers.find(r => r.ID == stOrder.customerPortalUserId) ? defaultValues.PortalUsers.find(r => r.ID == stOrder.customerPortalUserId).Role : ""}));

  
          // code block
          break;  
      case 'Consumer':
        console.log('Consumer');

          dispatch(updateConsumerData({selectedRowId : rowId , Value : e.target.value }));
  
          // code block
          //console.log(props.row.Number);
          break;
      case 'Optician':
        console.log('Optician');
        dispatch(updateOpticianData({selectedRowId : rowId , Value : e.target.value }));
  
          // code block
          //console.log(props.row.Number);
          break;
      case 'Axis':
        console.log('Axis');
        dispatch(updateAxisData({selectedRowId : rowId , Value : e.target.value }));
  
          // code block
          //console.log(props.row.Number);
          break;  
      case 'NeedTools':
        console.log('NeedTools');
        console.log(e.target.value);
        dispatch(updateNeedToolsData({selectedRowId : rowId , Value : e.target.checked }));
  
          // code block
          //console.log(props.row.Number);
          break;    
      case 'NeedCut':
        console.log('NeedCut');
        console.log(e.target.value);
        dispatch(updateNeedCutData({selectedRowId : rowId , Value : e.target.value }));
  
          // code block
          //console.log(props.row.Number);
          break;       
      default:
        // code block
    }
  
  }
  
  function rowKeyGetter(row) {
    return row.RowId;
  }

  
  function EmptyRowsRenderer() {
    return (
    
      <div style={{ textAlign: 'center', gridColumn: '1/-1' }}>
        {stOrder.loading ? '' :   ' اطلاعاتی برای نمایش وجود ندارد' }
      </div>
    );
  }

   let dataSource  = [];
   //console.log(invoices.selectedInvoice);
   if(stOrder.items != undefined && stOrder.items !== undefined && stOrder.items.length > 0)
   {
       dataSource = stOrder.items;//.map((item, i) => ({...item, rowIndex : i+1}));
       //dataSource = stOrder.items.map((item, i) => ({...item, rowIndex : i+1}));
   }


  var lensBrandOptions = [];
  if(stOrder.lensbrands !== undefined){
    stOrder.lensbrands.map(x => { 
      lensBrandOptions.push({ id: x.Value, label: x.Name});
    });
  }

  var lensTypeOptions = [];
  if(stOrder.lensTypes !== undefined){
    stOrder.lensTypes.map(x => { 
    lensTypeOptions.push({ id: x.Value, label: x.Name});
  });
}
  var lensIndexOptions = [];
  if(stOrder.lensIndexes !== undefined){
    stOrder.lensIndexes.map(x => { 
      lensIndexOptions.push({ id: x.Value, label: x.Name});
  });
}
  var lensSphOptions = [];
  if(stOrder.lensSphs !== undefined){
  stOrder.lensSphs.map(x => { 
    lensSphOptions.push({ id: x.Value, label: x.Name});
  });
}
  var lensCylOptions = [];
  if(stOrder.lensCyls !== undefined){
  stOrder.lensCyls.map(x => { 
    lensCylOptions.push({ id: x.Value, label: x.Name});
  });
}

var productOptions = [];
if(stOrder.products !== undefined){
stOrder.products.map(x => { 
  productOptions.push({ id: x.Value, label: x.Name});
});
}

   const mdTheme = createTheme({
    typography: {
      fontFamily: [
        "mohammadfont",
        "Tahoma",
        "Verdana"
      ].join(",")
    },
    
    direction: 'rtl',
    components: {
      MuiTooltip: {
        styleOverrides: {
          tooltip: {
            backgroundColor: '#FBC02D',
            color: '#424242'
          },
        },
      },
    }
  });

const handleLensBrandChange = (event, value) =>{

  console.log(event);
  console.log(value);
  if(value === null){
    dispatch(setSTOrderSelectedLensBrand(0));
  }else{
    dispatch(setSTOrderSelectedLensBrand(value.id));
    dispatch(fetchLensTypes({selectedLensBrandId: value.id, authUser}));
  }
}
const handleLensTypeChange = (event, value) =>{

  console.log(event);
  console.log(value);
  if(value === null){
    dispatch(setSTOrderSelectedLensType(0));
  }else{
    dispatch(setSTOrderSelectedLensType(value.id));
    dispatch(fetchLensIndexes({ selectedLensBrandId: stOrder.selectedLensBrandId, selectedLensTypeId : value.id, authUser}));
  }
  
}
const handleLensIndexChange = (event, value) =>{

  console.log(event);
  console.log(value);
  if(value === null){
    dispatch(setSTOrderSelectedLensIndex(0));
  }else{
    dispatch(setSTOrderSelectedLensIndex(value.id));
    dispatch(fetchLensSphs({ selectedLensBrandId: stOrder.selectedLensBrandId, selectedLensTypeId : stOrder.selectedLensTypeId, selectedLensIndexId : value.id , authUser}));
  }
}
const handleLensSphChange = (event, value) =>{

  console.log(event);
  console.log(value);
  if(value === null){
    dispatch(setSTOrderSelectedLensSph(0));
  }else{
    dispatch(setSTOrderSelectedLensSph(value.id));
    dispatch(fetchLensCyls({ selectedLensBrandId: stOrder.selectedLensBrandId, selectedLensTypeId : stOrder.selectedLensTypeId, selectedLensIndexId : stOrder.selectedLensIndexId, selectedLensSphid : value.id, authUser}));
  }
}

const handleLensCylChange = (event, value) =>{

  console.log(event);
  console.log(value);
  if(value === null){
    dispatch(setSTOrderSelectedLensCyl(0));
  }else{
    dispatch(setSTOrderSelectedLensCyl(value.id));
    dispatch(fetchProducts({selectedLensBrandId: stOrder.selectedLensBrandId, selectedLensTypeId : stOrder.selectedLensTypeId, selectedLensIndexId : stOrder.selectedLensIndexId, selectedLensSphid : stOrder.selectedLensSphId , selectedCylId : value.id, authUser}));
  }
}

const handleProductChange = (event, value) => {

  console.log(event);
  console.log(value);

  if(value === null){
    dispatch(setSTOrderSelectedProduct(null));
  }else{

    if (stOrder.products.find(r => r.Value === value.id.toString())) {
      var selectedProduct = stOrder.products.find(r => r.Value === value.id.toString());
      dispatch(setSTOrderSelectedProduct({selectedProductId : selectedProduct.Value , selectedProductCode : selectedProduct.Code, selectedProductTitle : selectedProduct.Name , selectedFee : selectedProduct.Fee , authUser }));
  
    }
      //dispatch(fetchProducts({selectedLensBrandId: stOrder.selectedLensBrandId, selectedLensTypeId : stOrder.selectedLensTypeId, selectedLensIndexId : stOrder.selectedLensIndexId, selectedLensSphid : stOrder.selectedLensSphId , selectedCylId : value.id, authUser}));
  }
}
const handleCustomerPortalUserChange = (event, value) => {

  console.log(event);
  console.log(value);

  if(value === null){
    dispatch(clearCustomerPortalUserId(null));
  }else{
    dispatch(setCustomerPortalUserId(value.id.toString()));
  }
}
const handleQuantityChange = (e) =>{

  console.log(e.target.value);
  dispatch(setSTOrderSelectedQuantity(removeComma(e.target.value)));

}

const handleAdd = () =>{
   console.log("stOrder");
   console.log(stOrder);
   dispatch(addOrUpdateItem({selectedRowId : 0 , selectedProductId : stOrder.selectedProductId , selectedProductCode : stOrder.selectedProductCode, selectedProductTitle : stOrder.selectedProductTitle , selectedQuantity : stOrder.selectedQuantity , selectedFee : stOrder.selectedFee , addQuantityToCurrent : true , authUser, customerPortalFinalserRole : defaultValues.PortalUsers.find(r => r.ID == stOrder.customerPortalUserId) ? defaultValues.PortalUsers.find(r => r.ID == stOrder.customerPortalUserId).Role : ""}));

}
const handleRightSwitch = (e) =>{
  dispatch(setRightValue(e.target.checked))
}
const handleLeftSwitch = (e) =>{
  dispatch(setLeftValue(e.target.checked))
}
const handleOUSwitch = (e) =>{
  dispatch(setOUValue(e.target.checked))
}

const onBackClicked = (e) =>{

  navigate('/soorders');

}

let timeout =  0;
var timeToSearch = 200;
const doBarcode = (e) => {
  //dispatch(resetItems());
  //
  //
  //dispatch(
  //  changeFocus('')
  //);
  var searchText = e.target.value; // this is the search text
  //
    console.log(searchText);
    console.log(doBarcode);
    if(timeout) clearTimeout(timeout);
    timeout = setTimeout(() => {
     
      dispatch(fetchProduct( {code : searchText , isFromBarcode : true , authUser}));
      console.log(barcodeItemRef);
      barcodeItemRef.current.value = '';

    }, timeToSearch);

};


  return (
    <>

<ThemeProvider theme={mdTheme}>

  <Box sx={{ flexGrow: 1 }}>
     
     <Grid container>
              <Grid item xs={12}>
                       
      <Accordion defaultExpanded={true}>
             
                <AccordionDetails>
                <Grid container 
                  spacing={1}
                  direction={{ xs: 'column', sm : 'row-reverse' , md: 'row-reverse' , lg : 'row-reverse'}}
                  justifyContent={{ xs: 'center', md: 'center', lg : 'center', sm : 'center' }}
                  alignItems={{ xs: 'center', md: 'center', lg : 'center', sm : 'center' }}
                  columns={{ xs: 4, sm: 4, md: 8 }}
                >
                    <Box sx={{ display: 'flex', alignItems: 'flex-end' }}>
                    <AppsIcon sx={{ color: 'action.active', mr: 1, my: 0.5 }} />
                    <Button variant="contained" onClick={handleOpenMatrix} disabled={!(stOrder.selectedLensBrandId > 0 && stOrder.selectedLensTypeId > 0 && stOrder.selectedLensIndexId > 0 && stOrder.selectedLensCylId === 0 && stOrder.selectedLensSphId === 0 )}>اضافه از ماتریس</Button>
                  </Box>
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <Box sx={{ display: 'flex', alignItems: 'flex-end' }}>
                    <QrCode2Icon sx={{ color: 'action.active', mr: 1, my: 0.5 }} />
                    <TextField id="input-with-sx" label="Barcode" variant="standard"
                    sx={{
                      width: 380 ,
                      '.MuiInputBase-input': { fontSize: '13px' },
                    }}
                    size="small"
                    autoComplete='off'
                    inputRef={barcodeItemRef}
                    onChange={evt => doBarcode(evt)}
                    />
                  </Box>
                 
                  </Grid>
                  <Grid container 
                    spacing={1}
                    direction={{ xs: 'column', sm : 'row-reverse' , md: 'row-reverse' , lg : 'row-reverse'}}
                    justifyContent={{ xs: 'center', md: 'center', lg : 'center', sm : 'center' }}
                    alignItems={{ xs: 'center', md: 'center', lg : 'center', sm : 'center' }}
                    columns={{ xs: 4, sm: 4, md: 8 }}
                  >
                        <Tooltip title="فعال سازی اطلاعات چشم راست">
                   <FormControlLabel
                        value="top"
                        control={<Switch color="primary" checked={stOrder.isRightOn} onChange={handleRightSwitch} disabled={stOrder.selectedRowId > 0 || stOrder.isOUOn} />}
                        label={stOrder.isRightOn ? <Iconr2/> : <Iconr1/> }
                        labelPlacement="top"
                    />
                       </Tooltip>
                      <Tooltip title="فعال سازی چشم راست و چپ یکسان">
                    <FormControlLabel
                        value="top"
                        control={<Switch color="primary" checked={stOrder.isOUOn} onChange={handleOUSwitch} disabled={stOrder.selectedRowId > 0 || stOrder.isLeftOn || stOrder.isRightOn} />}
                        label={stOrder.isOUOn ? <Iconou2/> : <Iconou1/> }
                        labelPlacement="top"
                      />
                      </Tooltip>
                      <Tooltip title="فعال سازی اطلاعات چشم چپ">
                    <FormControlLabel
                        value="top"
                        control={<Switch color="primary" checked={stOrder.isLeftOn} onChange={handleLeftSwitch} disabled={!(stOrder.selectedRowId > 0) || stOrder.isOUOn}/>}
                        label={stOrder.isLeftOn ? <Iconl2/> : <Iconl1/>}
                        labelPlacement="top"
                      />
                       </Tooltip>
                </Grid>
                <Grid container 
                  spacing={1}
                  direction={{ xs: 'column', sm : 'row-reverse' , md: 'row-reverse' , lg : 'row-reverse'}}
                  justifyContent={{ xs: 'center', md: 'center', lg : 'center', sm : 'center' }}
                  alignItems={{ xs: 'center', md: 'center', lg : 'center', sm : 'center' }}
                  columns={{ xs: 4, sm: 4, md: 8 }}>
                     
                         
                      <Autocomplete
                        disablePortal
                        id="combo-box-demo"
                        options={lensBrandOptions}
                        renderInput={(params) => <TextField {...params} label="Brand" 
                        sx={{
                          width: 155,
                          '.MuiInputBase-input': { fontSize: '13px' },
                        }}
                        />}
                        renderOption={(props, option, state) => 
                          <div {...props} style={{ textAlign : "left" , direction : "ltr" }}>
                            {option.label}
                          </div>
                        }
                        isOptionEqualToValue={(option, value) =>  option.id === stOrder.selectedLensBrandId}
                        onChange={handleLensBrandChange}
                        
                        value={stOrder.selectedLensBrandId > 0 ? lensBrandOptions.find(r => r.id == stOrder.selectedLensBrandId).label : ''}
                        size="small"
                        noOptionsText={<span className='noDataText'>اطلاعاتی یافت نشد</span>}
                        disabled={stOrder.isLeftOn}
                        autoHighlight='true'
                      />
                      
                        <Autocomplete
                        disablePortal
                        id="combo-box-demo"
                        options={lensTypeOptions}
                        //sx={{ width: 170 }}
                        renderInput={(params) => <TextField {...params} label="Type" 
                        sx={{
                          width: 155,
                          '.MuiInputBase-input': { fontSize: '13px' },
                        }}
                        />}
                        renderOption={(props, option, state) => 
                          <div {...props} style={{ textAlign : "left" , direction : "ltr" }}>
                            {option.label}
                          </div>
                        }
                        onChange={handleLensTypeChange}
                        isOptionEqualToValue={(option, value) =>  option.id === stOrder.selectedLensTypeId}
                        
                        value={stOrder.selectedLensTypeId > 0 ? lensTypeOptions.find(r => r.id == stOrder.selectedLensTypeId).label : ''}
                        size="small"
                        noOptionsText={<span className='noDataText'>اطلاعاتی یافت نشد</span>}
                        disabled={stOrder.isLeftOn}
                        autoHighlight='true'
                      />
                      
                      
                      <Autocomplete
                        disablePortal
                        id="combo-box-demo"
                        options={lensIndexOptions}
                        //sx={{ width: 170 }}
                        renderInput={(params) => <TextField {...params} label="Index" 
                        sx={{
                          width: 155,
                          '.MuiInputBase-input': { fontSize: '13px' },
                        }}
                        />}
                        renderOption={(props, option, state) => 
                          <div {...props} style={{ textAlign : "left" , direction : "ltr" }}>
                            {option.label}
                          </div>
                        }
                        onChange={handleLensIndexChange}
                        isOptionEqualToValue={(option, value) =>  option.id === stOrder.selectedLensIndexId}
                        value={stOrder.selectedLensIndexId > 0 ? lensIndexOptions.find(r => r.id == stOrder.selectedLensIndexId).label : ''}
                        size="small"
                        noOptionsText={<span className='noDataText'>اطلاعاتی یافت نشد</span>}
                        disabled={stOrder.isLeftOn}
                        autoHighlight='true'
                      />
                      
                      
                      <Autocomplete
                        disablePortal
                        id="combo-box-demo"
                        options={lensSphOptions}
                        //sx={{ width: 170 }}
                        renderInput={(params) => <TextField {...params} label="SPH" style={{ textAlign : "left" , direction : "ltr" }}
                        sx={{
                          width: 155,
                          '.MuiInputBase-input': { fontSize: '13px' },
                        }}
                        />}
                        renderOption={(props, option, state) => 
                          <div {...props} style={{ textAlign : "left" , direction : "ltr" }}>
                            {option.label}
                          </div>
                        }
                        onChange={handleLensSphChange}
                        isOptionEqualToValue={(option, value) =>  option.id === stOrder.selectedLensSphId}
                        value={stOrder.selectedLensSphId > 0 && lensSphOptions !== null && lensSphOptions !== undefined && lensSphOptions.length > 0 ? lensSphOptions.find(r => r.id == stOrder.selectedLensSphId).label : ''}
                        size="small"
                        noOptionsText={<span className='noDataText'>اطلاعاتی یافت نشد</span>}
                        autoHighlight='true'
                      />
                       
                       
                    <Autocomplete
                        disablePortal
                        id="combo-box-demo"
                        options={lensCylOptions}
                        //sx={{ width: 170 }}
                        renderInput={(params) => <TextField {...params} label="CYL" style={{ textAlign : "left" , direction : "ltr" }}
                        sx={{
                          width: 155,
                          '.MuiInputBase-input': { fontSize: '13px' },
                        }}
                        />}
                        renderOption={(props, option, state) => 
                          <div {...props} style={{ textAlign : "left" , direction : "ltr" }}>
                            {option.label}
                          </div>
                        }
                        onChange={handleLensCylChange}
                        isOptionEqualToValue={(option, value) =>  option.id === stOrder.selectedLensCylId}
                        value={stOrder.selectedLensCylId > 0 && lensCylOptions !== null && lensCylOptions !== undefined && lensCylOptions.length > 0 ? lensCylOptions.find(r => r.id == stOrder.selectedLensCylId).label : ''}
                        size="small"
                        noOptionsText={<span className='noDataText'>اطلاعاتی یافت نشد</span>}
                        autoHighlight='true'
                      />

                      <TextField
                        id="outlined-helperText"
                        label="Qty"
                        value={stOrder.selectedQuantity}
                        //defaultValue="1"
                        //helperText={تعداد}
                        autoComplete='off'
                        sx={{
                          width: 80 ,
                          '.MuiInputBase-input': { fontSize: '13px' },
                        }}
                        onChange={handleQuantityChange}
                        size="small"
                        disabled={stOrder.isRightOn || stOrder.isLeftOn || stOrder.isOUOn}
                          />
                      <Tooltip title="اضافه به لیست"><IconButton color="secondary" aria-label="add an alarm" sx={{ width: 50 }} onClick={handleAdd} disabled={stOrder.selectedQuantity <= 0}>
                        <AddBoxIcon className='addButton' /> 
                      </IconButton></Tooltip>
                </Grid>
                <Grid container 
                  spacing={1}
                  direction={{ xs: 'column', sm : 'row-reverse' , md: 'row-reverse' , lg : 'row-reverse'}}
                  justifyContent={{ xs: 'center', md: 'center', lg : 'center', sm : 'center' }}
                  alignItems={{ xs: 'center', md: 'center', lg : 'center', sm : 'center' }}
                  columns={{ xs: 4, sm: 4, md: 8 }}>
{stOrder.selectedProductId > 0 ?
                  <Box sx={{ border: 1 , borderColor: 'primary.main', width : '600px' }}>
                    <Typography variant="h6" component="h6" style={{ textAlign : "center" , direction : "ltr" , color : "#3F51B5" }}> 
                     {productOptions.find(r => r.id == stOrder.selectedProductId).label }
                    </Typography>
                    </Box>
                    : ''}

                 </Grid>
                </AccordionDetails>
          </Accordion>
             </Grid>
     </Grid>
     </Box>

<DataGrid 
    renderers={{ noRowsFallback: <EmptyRowsRenderer /> }}
    direction="rtl" 
    columns={columns} 
    rows={dataSource} 
    rowKeyGetter={rowKeyGetter}
    rowHeight={50}
    //style={{height : dynamicHeight}}
    />


<Box sx={{ flexGrow: 1 }}>
     
     <Grid container>
              <Grid item xs={12}>
                       
                        <Accordion expanded={true}>
                <AccordionSummary
                  //expandIcon={<ArrowDownwardIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-footer"
                >
           
                </AccordionSummary>
                <AccordionDetails >
                <Box textAlign='center'>
                <Grid container 
                spacing={{ xs: 1, md: 1 }} 
                columns={{ xs: 4, sm: 8, md: 12 }}
                direction={{ xs: 'column', sm : 'row-reverse' , md: 'row-reverse' , lg : 'row-reverse'}}
                >

                <Grid xs={12} sm={8} md={8} lg={8} key={30007}>
             
            <TextField
                    type="text"
                    label="توضیحات"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    sx={{
                      //width: 135,
                      '.MuiInputBase-input': { fontSize: '13px' },
                    }}
                    helperText="توضیحات شما راجع به سفارش"
                    fullWidth
                    variant="standard"
                    value={stOrder.description}
                    onChange={evt => handleDescriptionChange(evt)}
                  />
              </Grid>

              <Grid xs={12} sm={2} md={2} lg={2} key={30008}>
              <Controller
                          name="مشتری"
                          render={({ field }) => (
                            <Autocomplete
                            options={authUser.underControlUsers.map(x => ({ id: x.Value, label: x.Code + ' ' + x.Name}))}
                            //getOptionLabel={option => option}
                            renderOption={(props, option, state) => 
                              <div {...props} style={{ textAlign : "left" , direction : "ltr" }}>
                                {option.label}
                              </div>
                            }
                            //filterSelectedOptions
                            renderInput={params => (
                              <TextField
                                {...params}
                                error={stOrder.customerPortalUserId === undefined || stOrder.customerPortalUserId === null || stOrder.customerPortalUserId === ""}
                                helperText="مشتری"
                                variant="outlined"
                                label="مشتری"
                                placeholder=""
                                sx={{
                                  //width: 135,
                                  '.MuiInputBase-input': { fontSize: '13px' },
                                }}
                              />
                            )}
                            onChange={handleCustomerPortalUserChange}
                            //isOptionEqualToValue={(option, value) =>  option.id === value.id}
                            value={stOrder.customerPortalUserId !== undefined && stOrder.customerPortalUserId !== null && stOrder.customerPortalUserId !== "" ? authUser.underControlUsers.find(r => r.Value == stOrder.customerPortalUserId).Code : ''}
                            size="small"
                            noOptionsText={<span className='noDataText'>اطلاعاتی یافت نشد</span>}
                            autoHighlight='true'
                            //disabled={(stOrder.LSPH === null)}
                          />
                          )}
                          control={control}
                          rules={{
                            validate: d => {
                              return d.length > 0;
                            }
                          }}
                        />

                </Grid>
 </Grid>
                     
           <Tooltip title="ثبت سفارش با پیش نمایش ">
           <Button className='mmgBtnSubmit' disabled={stOrder.items <= 0 || stOrder.loading || stOrder.customerPortalUserId === ""} color="success" onClick={handleSubmitOrder} variant="outlined" startIcon={<BeenhereIcon />}>
                    ثبت سفارش با پیش نمایش 
           </Button>
          
           </Tooltip>
           &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
           <Tooltip title="ثبت سفارش مستقیم">
           <Button className='mmgBtnSubmit' disabled={stOrder.items <= 0 || stOrder.loading || stOrder.customerPortalUserId === ""} color="success" onClick={handleDirectSubmitOrder} variant="outlined" startIcon={<BeenhereIcon />}>
                    ثبت سفارش مستقیم
           </Button>
           </Tooltip> 
           {authUser.username === "test" ?
          
           <Tooltip title="ثبت سفارش و پرداخت">
           <Button className='mmgBtnSubmit' disabled={stOrder.items <= 0 || stOrder.loading || stOrder.customerPortalUserId === ""} color="success" onClick={handleDirectSubmitOrderOnlinePayment} variant="outlined" startIcon={<BeenhereIcon />}>
           ثبت سفارش و پرداخت
           </Button>
           </Tooltip>  : ""
           }

         
            </Box>
                </AccordionDetails>
              
          </Accordion>
             </Grid>
     </Grid>
     </Box>

    <STPreviewItems />

            <Dialog
              open={stOrder.boxType > 0}
              //onClose={handleCloseMessageBox}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
             >
              <DialogTitle id="alert-dialog-title">
                {"نتیجه عملیات"}
              </DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                <Alert severity={stOrder.boxType === 1 ? "error" : (stOrder.boxType === 2 ? "success" : "info")}>
                <Typography
                    variant="span"
                    color="primary"
                    dangerouslySetInnerHTML={{ __html: stOrder.boxMessage }}>
                    
                </Typography>
             
                  </Alert>
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                {stOrder.boxType === 2 ?   
                <Grid container justify='space-between' spacing={2}>
                <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                <Button fullWidth variant="contained" color='success' onClick={handleCloseMessageBox}>
                سفارش جدید
              </Button>
                </Grid>
                <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                <Button fullWidth variant="contained" color='success' onClick={handleCloseMessageBoxAndGotoOrderList}>
                پیگیری سفارش
              </Button>
                </Grid>
            </Grid>
                : 
               
               <Button variant="contained" color='error' onClick={handleCloseMessageBox}>
                     خب
              </Button>
              }
              </DialogActions>
            </Dialog>
          
    {stOrder.loading ?   <div className="LoadingDiv">در حال تبادل اطلاعات <LinearProgress color="inherit" /></div>: "" }
    <Dialog
              open={open}
              //onClose={handleClose}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogTitle id="alert-dialog-title">
                {"تایید "}
              </DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                 آیا از ثبت نهایی سفارش اطمینان دارید؟
                </DialogContentText>
              </DialogContent>
              <DialogActions>
              <Button variant="contained" color='success' startIcon={<CheckIcon />} onClick={handleYes}>
                بله
              </Button>
              <Button variant="contained" color='error' startIcon={<CancelIcon/>} onClick={handleNo}>
                خیر
              </Button>
            

              </DialogActions>
            </Dialog>
    </ThemeProvider>
    </>
  );
}

export default ST;